
export const cd = (classMap) => {
    return Object.keys(classMap).filter((className) => classMap[className]).join(' ');
}